import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ImgGramInfoPage = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (direction === "left") {
      current.scrollBy({ left: -300, behavior: "smooth" });
    } else {
      current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const images = [
    "../gal-img1.jpg",
    "../gal-img2.jpg",
    "../gal-img3.jpg",
    "../gal-img4.jpg",
    "../gal-img5.jpg",
  ];

  return (
    <div className="relative max-w-6xl mx-auto py-10">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">छायाचित्र दालन</h2>

      <div className="relative">
        {/* Left Arrow */}
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-100 transition"
        >
          <ChevronLeft size={24} />
        </button>

        {/* Images Container */}
        <div
          ref={scrollRef}
          className="flex overflow-x-auto space-x-4 scroll-smooth"
          style={{
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE 10+
          }}
        >
          {images.map((img, index) => (
            <div key={index} className="min-w-[200px] flex-shrink-0">
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                className="rounded-lg object-cover w-full h-48 hover:scale-105 transition-transform"
              />
            </div>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-100 transition"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default ImgGramInfoPage;
